<template>
  <div class="h-[77px] w-[100vw] overflow-hidden bg-black z-10 relative">
    <BaseContainer class="w-full h-full">
      <div class="h-full flex justify-between items-center">
        <div class="text-white">
          <div>
            <NuxtLinkLocale to="/"> <SvgCaseClubLogo /></NuxtLinkLocale>
          </div>
        </div>
        <div
          class="text-primary-white text-xl cursor-pointer hover:opacity-50"
          @click="() => router.push(localePath('/'))"
        >
          {{ $t('checkout.continueShopping') }}
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
const router = useRouter()
const localePath = useLocalePath()
</script>
